import React from 'react';

import { THorizontalAlign } from '../../../../models/THorizontalAlign.js';
import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { IPillProps } from '../../Pill/models/index.js';
import Pill from '../../Pill/Pill.js';
import { ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY } from '../IconInput.meta.js';

const InputPill = (props: IPillProps & { pillPosition?: THorizontalAlign }) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { pillPosition, ...pillProps } = props;
	return <Pill {...pillProps} />;
};

export default InjectedStyledComponent(InputPill, ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY, ['inputPill']);
